// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { startOfQuarter as fn } from "../startOfQuarter.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const startOfQuarterWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default startOfQuarterWithOptions;
